import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Gift, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VoucherRedeem = ({ serviceId, voucher, setVoucher }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const apply = async () => {
    if (!code.trim()) return;
    setLoading(true);
    try {
      const r = await axios.get(`${API}/vouchers/${encodeURIComponent(code.trim().toUpperCase())}/check`, { params: { service_id: serviceId } });
      setVoucher(r.data);
      toast.success(`Gift card applied: $${r.data.balance.toFixed(2)} available`);
    } catch (e) {
      setVoucher(null);
      toast.error(e.response?.data?.detail || "Gift card not found");
    }
    setLoading(false);
  };

  if (voucher) {
    return (
      <div className="mb-4 flex items-center justify-between rounded-lg border border-amber-300/40 bg-amber-300/10 px-3 py-2" data-testid="booking-voucher-applied">
        <span className="text-amber-200 text-sm flex items-center gap-2"><Gift className="w-4 h-4" /> {voucher.code} · {voucher.label}</span>
        <button type="button" onClick={() => setVoucher(null)} className="text-white/60 hover:text-white" data-testid="booking-voucher-remove"><X className="w-4 h-4" /></button>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <p className="text-white/60 mb-2 text-sm">Gift Card / Voucher (Optional)</p>
      <div className="flex gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="DMRG-XXXX-XXXX" className="bg-dream-bg border-dream-border text-white flex-1" data-testid="booking-voucher-input" />
        <Button type="button" onClick={apply} disabled={loading || !code.trim()} className="bg-dream-surface border border-dream-border text-white hover:border-amber-300" data-testid="booking-voucher-apply">
          {loading ? "..." : "Apply"}
        </Button>
      </div>
    </div>
  );
};
